<script>
import { defineComponent as _defineComponent } from "vue";
import { renderSlot as _renderSlot, mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { provide } from "vue";
import { defu } from "defu";
import { useCookieState } from "../composables/private/useCookieState";
import { defaultOptions } from "../utils/defaultOptions";
import { MagicCookieInstanceId } from "../symbols";
export default /* @__PURE__ */ _defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "MagicCookieProvider",
  props: {
    id: { type: null, required: true },
    options: { type: Object, required: false }
  },
  setup(__props) {
    const mappedOptions = defu(__props.options, defaultOptions);
    const { initializeState } = useCookieState(__props.id);
    initializeState(mappedOptions);
    provide(MagicCookieInstanceId, __props.id);
    return (_ctx, _cache) => {
      const _component_client_only = _resolveComponent("client-only");
      return _openBlock(), _createBlock(_component_client_only, null, {
        default: _withCtx(() => [
          _createElementVNode(
            "div",
            _mergeProps({ class: "magic-cookie-provider" }, _ctx.$attrs),
            [
              _renderSlot(_ctx.$slots, "default")
            ],
            16
            /* FULL_PROPS */
          )
        ]),
        _: 3
        /* FORWARDED */
      });
    };
  }
});
</script>
